module.exports = __webpack_public_path__ + "static/img/icon_search.47b438b9.png";